
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ActivitiesSection from './components/ActivitiesSection';
import BenefitsSection from './components/BenefitsSection';
import WishesSection from './components/WishesSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ActivitiesSection />
        <BenefitsSection />
        <WishesSection />
      </main>
      <Footer />
    </div>
  );
}
